import { render, staticRenderFns } from "./BlockSelectAuto.vue?vue&type=template&id=3f670b5c&"
import script from "./BlockSelectAuto.vue?vue&type=script&lang=ts&"
export * from "./BlockSelectAuto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports